import { render, staticRenderFns } from "./auth.sessions.tabs.vue?vue&type=template&id=0aeef053&"
import script from "./auth.sessions.tabs.vue?vue&type=script&lang=ts&"
export * from "./auth.sessions.tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports